function TopicPillTag({ name }: { name: string }) {
  return (
    <span className="text-xs px-2.5 py-1 bg-iq-grey-light text-iq-grey-dark rounded whitespace-nowrap">
      {name}
    </span>
  );
}

export { TopicPillTag };
